import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CustomerSummaryComponent } from './customer-summary/customer-summary.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, CustomerSummaryComponent],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [HeaderComponent, FooterComponent]
})
export class StructureModule { }
